import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { NavigationService } from 'app/configuration/navigation/navigation.service';

import { NotificationsService } from './layout/components-common/notifications/notifications.service';
import { MessagesService } from './layout/components-common/messages/messages.service';

@Injectable({
    providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(
        private _navigationService: NavigationService,
        // private _shortcutsService: ShortcutsService,
        
        private _messagesService: MessagesService,
        private _notificationsService: NotificationsService
    ) { }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        // Fork join multiple API endpoint calls to wait all of them to finish
        return forkJoin([
            
            this._navigationService.get(),
            // this._notificationsService.getAll(),
            this._messagesService.getAll(),
            // this._userService.getDetail()
        ]);
    }
}
